import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 41" width="1em" height="1em">
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path
          strokeMiterlimit={10}
          stroke="fj-icons-primary-color"
          fill="fj-icons-bg-color"
          d="M.5.5h30v40H.5z"
        />
        <rect
          x={17.17}
          y={17.17}
          width={20}
          height={26.67}
          rx={0.67}
          ry={0.67}
          transform="rotate(90 27.17 30.5)"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="fj-icons-primary-color"
          fill="fj-icons-bg-color"
        />
        <path
          strokeWidth={0.75}
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="fj-icons-primary-color"
          fill="fj-icons-bg-color"
          d="M34.71 34.86v4.33l1.88-2.17 1.89 2.17v-4.33h-3.77z"
        />
        <circle
          cx={36.59}
          cy={33.37}
          r={2.51}
          strokeWidth={0.75}
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="fj-icons-primary-color"
          fill="fj-icons-bg-color"
        />
        <path
          fill="none"
          strokeWidth={0.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="fj-icons-primary-color"
          d="M16.28 23.63h22M16.28 25.47h22M16.28 27.31h22M16.28 29.16h22M16.28 34.94h10M16.28 36.66h10"
        />
        <path
          fill="fj-icons-primary-color"
          d="M2.6 2.8h4v6h-4zM9.73 2.8h4v6h-4zM16.86 2.8h4v6h-4zM23.98 2.8h4v6h-4zM2.6 11.62h4v6h-4zM2.6 20.44h4v6h-4z"
        />
        <path
          fill="none"
          strokeWidth={0.5}
          strokeMiterlimit={10}
          stroke="fj-icons-primary-color"
          d="M2.69 28.5h8v12h-8z"
        />
        <path
          fill="fj-icons-primary-color"
          d="M9.73 11.62h4v6h-4zM16.86 11.62h4v6h-4zM23.98 11.62h4v6h-4z"
        />
      </g>
    </g>
  </svg>
);

const InstitutionLicense = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default InstitutionLicense;
